import dayjs from "@/helpers/dayjs";

export default {
  mounted() {},
  computed: {
    //스토어에 저장되어있는 정보 리턴
    getDeliveryOptions() {
      return this.$store.getters["form/getDeliveryOptions"]();
    },
    getOrder() {
      return this.$store.getters["form/getOrder"]();
    },
    getPins() {
      return this.$store.getters["form/getPins"]();
    }
  },
  methods: {
    /**데이트 업데이트 관련 함수 */
    updateIsReserved(value) {
      this.$store.commit("form/updateIsReserved", value);
    },
    updateIsExpressDelivery(value) {
      this.$store.commit("form/updateIsExpressDelivery", value);
    },
    updatePickupTime(date, hour, minute) {
      const payload = {
        date: date ?? dayjs().format("YYYY-MM-DD"),
        hour: hour ?? dayjs().format("HH"),
        minute: minute ?? dayjs().format("mm")
      };
      this.$store.commit("form/updatePickupTime", payload);
    },
    updateVehicleCategory(value) {
      this.$store.commit("form/updateVehicleCategory", value);
    },
    updateVehicleItemCode(value) {
      this.$store.commit("form/updateVehicleItemCode", value);
    },
    updateDisplayFees(payload) {
      this.$store.commit("form/updateDisplayFess", payload);
    },

    updateEstimatedMinutes(payload) {
      this.$store.commit("form/updateEstimatedMinutes", payload);
    },
    updateVehicleType(value) {
      this.$store.commit("form/updateVehicleType", value);
    },
    updateVehicleOptions(value) {
      this.$store.commit("form/updateVehicleOptions", value);
    },
    updateLoadingPosition(value) {
      this.$store.commit("form/updateLoadingPosition", value);
    },
    updateUnLoadingPosition(value) {
      this.$store.commit("form/updateUnLoadingPosition", value);
    },
    updateLoadingMethod(value) {
      this.$store.commit("form/updateLoadingMethod", value);
    },
    updateUnLoadingMethod(value) {
      this.$store.commit("form/updateUnLoadingMethod", value);
    },
    updatePinMemo(value, idx) {
      const payload = {
        memo: value,
        idx: idx
      };
      this.$store.commit("form/updatePinMemo", payload);
    },
    updateClientComment(value) {
      this.$store.commit("form/updateClientComment", value);
    },
    updateApplicantName(value) {
      this.$store.commit("form/updateApplicantName", value);
    },
    updateApplicantPhoneNumber(value) {
      this.$store.commit("form/updateApplicantPhoneNumber", value);
    },
    updateClientMemo(value) {
      this.$store.commit("form/updateClientMemo", value);
    },
    updatePinFromModal(payload) {
      this.$store.commit("form/updatePinFromModal", payload);
    },
    updatePinName(payload) {
      this.$store.commit("form/updatePinName", payload);
    },
    updatePhoneNumber(payload) {
      this.$store.commit("form/updatePhoneNumber", payload);
    },

    updatePins(pins) {
      this.$store.commit("form/updatePins", pins);
    },

    updateDeliveryOptions(deliveryOptions) {
      this.$store.commit("form/updateDeliveryOptions", deliveryOptions);
    },

    updateWeight(value) {
      this.$store.commit("form/updateWeight", value);
    },

    updateItem(key, number, isOn) {
      const payload = {
        key: key,
        number: number,
        on: isOn
      };
      this.$store.commit("form/updateItem", payload);
    },
    updateItemEtc(isOn, value) {
      let payload;
      if (value === "") {
        payload = {
          on: isOn,
          content: null
        };
      } else {
        payload = {
          on: isOn,
          content: value
        };
      }
      this.$store.commit("form/updateItemEtc", payload);
    },

    updateAddToBookmark(value, idx) {
      const payload = {
        value: value,
        idx: idx
      };
      this.$store.commit("form/updateAddToBookmark", payload);
    }
  }
};
